<dx-toolbar>
  <dxi-item
    *ngIf="!readOnlyUser('dataqualitystatsexport')"
    location="before"
    widget="dxButton"
    [options]="{
      stylingMode: 'outlined',
      type: 'default',
      text: ('Details exportieren' | translate),
      onClick: exportDetails
    }">
  </dxi-item>
</dx-toolbar>

<div *ngIf="catalogDataQuality" class="dx-fieldset data-quality-statistics">
  <dx-tab-panel
    class="data-quality-statistics-tabs"
    [dataSource]="catalogDataQuality.catalogDataQualityTable"
    [selectedIndex]="0"
    [loop]="false"
    [animationEnabled]="true"
    [swipeEnabled]="true">

    <div *dxTemplate="let table of 'title'">
      {{ table.headline }}
    </div>

    <div *dxTemplate="let table of 'item'">
      <dx-data-grid
        class="data-quality-statistics-grid"
        [dataSource]="table.lines"
        [showBorders]="false"
        [rowAlternationEnabled]="true">

        <dxi-column dataField="name" cellTemplate="cellTemplateName" caption="{{ 'Regel' | translate }}"></dxi-column>
        <div *dxTemplate="let cell of 'cellTemplateName'">
          <div class="data-quality-statistics-name">{{ cell.text }}</div>
        </div>

        <dxi-column dataField="hits" width="150" cellTemplate="cellTemplateHits" caption="{{ 'Valide Produkte' | translate }}"></dxi-column>
        <div *dxTemplate="let cell of 'cellTemplateHits'">
          <div class="data-quality-statistics-hits">{{ cell.text }}</div>
        </div>

        <dxi-column dataField="total" width="150" cellTemplate="cellTemplateTotal" caption="{{ 'Produkt-Anzahl' | translate }}"></dxi-column>
        <div *dxTemplate="let cell of 'cellTemplateTotal'">
          <div class="data-quality-statistics-total">{{ cell.text }}</div>
        </div>

        <dxi-column dataField="targetType" width="200" cellTemplate="cellTemplateTargetType" caption="{{ 'Angewendet auf' | translate }}"></dxi-column>
        <div *dxTemplate="let cell of 'cellTemplateTargetType'">
          <div class="data-quality-statistics-target">{{ cell.text | translate }}</div>
        </div>
      </dx-data-grid>
    </div>
  </dx-tab-panel>
</div>
